import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { Chart } from 'chart.js';
@Component({
    selector: 'homeleite-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogsComponent implements OnInit {
    days = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex'];
    @ViewChild('canvas', { static: true }) element: ElementRef;

    constructor() {}

    ngOnInit() {
        new Chart(this.element.nativeElement, {
            type: 'line',
            data: {
                labels: this.days,
                datasets: [{ data: [83, 12, 2, 99, 8, 7, 63, 66, 28] }]
            }
        });
    }
}
